import React, { Component } from "react";
import "../initialPage/initial.scss";
import { Col, Row, Container, Navbar, NavbarBrand } from 'bootstrap-4-react';

class HeaderDirectorPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
     
    }

  }

  componentDidMount() { }

  render() {
    const { typeHeader, signedIn,openMenu } = this.props.initState

    return (
      <>
        <div
        className={`ws-navbar-name ${(openMenu) ? 'hide-navbar-name' : '' }`}
        >
          Emmanuel
        </div>
        <Navbar light expand="md" sticky={'top'} className={`headerPagePos ${(openMenu) ? 'left-header0' : '' }`} style={{display:'flex',justifyContent:'space-between'}}>
            <img 
            alt={"Logo"} 
            src={`img/pos2/${ (openMenu) ? 'menu-open' : 'menu-close'}.svg`} 
            className="headerPagePos__logo"
            onClick={(e) => { 
              this.initsetState({openMenu: !openMenu})
            }} 
            />
        
            <img src={'img/pos2/sadett-header.svg'} alt="logo-sadett" style={{width:50,height:50}}/>
          <p
            onClick={() => {
              localStorage.removeItem('nutrisadett_app_s');
              window.location.reload()
            }}
            className="initialPage__headerText" 
            style={{ lineHeight: '13px', textAlign: 'left', paddingLeft: '10px', fontSize: '.8rem', fontWeight: 'bold', cursor: 'pointer', alignSelf:'right' }}>Cerrar sesión</p>
        </Navbar>
      </>
    )

    return (
      <div style={{ background: '#44bd32', height: 190, overflow: 'hidden', position: 'absolute', top: 0, left: 0, right: 0, zIndex: 1, }} >
        <Container>
          <Row className={'headerDirector__row'}>
            <Col xs={'2'}>
              <img alt={"img"} src={'img/pos/logo.png'} className={'headerDirector__profile'} />
            </Col>
            <Col className={'headerDirector__description'}>
              <p>Bienvenido de nuevo,</p>
              <h4>{`${signedIn.nombre} ${signedIn.apellidos}`}</h4>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }

  initsetState(param) {
    this.props.initsetState(param)
    return true
  }

};

export default HeaderDirectorPage